import { ReactNode } from 'react';
import classNames from 'classnames';
import { ButtonSize } from '@app/components/button-size.ts';
import Spinner from '@app/components/spinner.tsx';
import { SpinnerSize } from '@app/components/spinner-size.ts';

export default function PrimaryButton(props: {
  id?: string;
  children?: ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  buttonSize?: ButtonSize;
  loading?: boolean;
  'data-testid'?: string;
}) {
  const size = props.buttonSize ?? ButtonSize.medium;

  return (
    <button
      id={props.id}
      data-testid={props['data-testid']}
      type="button"
      disabled={props.disabled ?? false}
      onClick={props.onClick}
      className={classNames(
        'relative rounded-md bg-black font-semibold text-white shadow-sm',
        'disabled:bg-gray-400',
        'hover:bg-gray-500',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600',
        props.className,
        {
          'px-2 py-1 text-xs': size === ButtonSize.small,
          'px-2 py-1 text-sm': size === ButtonSize.semiSmall,
          'px-2.5 py-1.5 text-sm': size === ButtonSize.medium,
          'px-3 py-2 text-sm': size === ButtonSize.semiLarge,
          'px-3.5 py-2.5 text-sm': size === ButtonSize.large,
        }
      )}
    >
      <div className={classNames('flex justify-center', props.loading && 'opacity-0')}>
        {props.children}
      </div>
      {props.loading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="h-4 w-4">
            <Spinner size={SpinnerSize.Small} />
          </div>
        </div>
      )}
    </button>
  );
}
